var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWagonLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7568 0C13.5525 0 14.3163 0.316262 14.8789 0.878906L17.1211 3.12109C17.6837 3.6837 18 4.44754 18 5.24316V6C17.5 6 17 6.5 17 7H18V7.99902C18 8.55131 17.5523 9 17 9H16.7305C16.3845 9.59733 15.7399 10 15 10C14.2601 10 13.6155 9.59733 13.2695 9H6.73047C6.38454 9.59733 5.73993 10 5 10C4.26007 10 3.61546 9.59733 3.26953 9H2C0.895431 9 0 8.10457 0 7V2C0 0.895431 0.895431 4.0266e-08 2 0H12.7568ZM5 7C4.44772 7 4 7.44772 4 8C4 8.55229 4.44772 9 5 9C5.55228 9 6 8.55229 6 8C6 7.44772 5.55228 7 5 7ZM15 7C14.4477 7 14 7.44772 14 8C14 8.55229 14.4477 9 15 9C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7ZM11 3C11 3.55228 11.4477 4 12 4H17L14.5859 1.58594C14.2109 1.21094 13.7022 1.00008 13.1719 1H11V3Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagonLightIcon);
export default __webpack_public_path__ + "static/media/wagon-light-icon.0b598c094d65377374c94388f382375a.svg";
export { ForwardRef as ReactComponent };